module.exports = __webpack_public_path__ + "img/extend-success.02bd6b17.png";